import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransformCamelCaseEsportsPipe } from './pipe.camel.case.esports';

@NgModule({
    declarations: [
        TransformCamelCaseEsportsPipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TransformCamelCaseEsportsPipe
    ]
})

// tslint:disable-next-line:no-unnecessary-class
export class TransformCamelCaseEsportsModule {}
